export class Category {
	constructor(idCategory, name, imageURL, routeURL) {
		this.idCategory = idCategory;
		this.name = name;
		this.imageURL = imageURL;
		this.routeURL = routeURL;
		this.subcategory = null;
	}
}
